import { useAppSelector } from "src/redux/hooks";
import {
    getActiveStore,
    getUserIsSnackpassEmployee,
} from "src/redux/selectors";
import { Routes } from "#navigation/routes";

import { RouteItem } from "../../types";
import { getSidebarSections } from "../sidebar-hierarchy";
import { getExcludedSidebarRoutes } from "../utils";

import { useRoutePermissions } from "./use-route-permissions";

function filterNavItems(
    items: readonly RouteItem[],
    shouldIncludeRoute: (route: Routes) => boolean,
): RouteItem[] {
    return items
        .filter((item) => shouldIncludeRoute(item.url))
        .map((item) => ({
            ...item,
            items: item.items
                ? filterNavItems(item.items, shouldIncludeRoute)
                : undefined,
        }));
}

export function useCreateSidebar() {
    const { hasRoutePermission } = useRoutePermissions();
    const activeStore = useAppSelector(getActiveStore);
    const isSnackpassEmployee = useAppSelector(getUserIsSnackpassEmployee);
    const excludedRoutes = getExcludedSidebarRoutes(
        activeStore,
        isSnackpassEmployee,
    );
    const sidebarSections = getSidebarSections();
    const sections = sidebarSections.map((section) => ({
        ...section,
        items: filterNavItems(
            section.items,
            (route) =>
                !excludedRoutes.includes(route) && hasRoutePermission(route),
        ),
    }));

    return { sections };
}
